import { ETypCennehoPapiru } from 'enums/isin/udaje/typCennehoPapiru';

const typCennehoPapiruSelect = [
    {
        value: ETypCennehoPapiru.RK,
        labelcz: 'ISIN_EMISE_KOLEKTIVNI_TYP_RETAIL'
    },
    {
        value: ETypCennehoPapiru.JK,
        labelcz: 'ISIN_EMISE_KOLEKTIVNI_TYP_KVALIF'
    }
];
export default typCennehoPapiruSelect;
